import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper, Content, Block, Title} from './FullOpeningTimes.style';
import OpeningTimes from '../ContactPage/OpeningTimes';

const FullOpeningTimes = props => {
  const {restaurant} = props;
  const renderDeliveryHours = restaurant.deliveryTimes && (
    <Block>
      <Title>Delivery Hours</Title>
      <OpeningTimes
        openingTimes={restaurant.deliveryTimes}
        restaurantModes={restaurant.modes}
      />
    </Block>
  );
  const renderCollectionHours = restaurant.collectionTimes && (
    <Block>
      <Title>Collection Hours</Title>
      <OpeningTimes
        openingTimes={restaurant.collectionTimes}
        restaurantModes={restaurant.modes}
      />
    </Block>
  );
  return (
    <Wrapper data-rw="full-opening-times">
      <Content>
        {renderDeliveryHours}
        {renderCollectionHours}
      </Content>
    </Wrapper>
  );
};

FullOpeningTimes.propTypes = {
  restaurant: PropTypes.object.isRequired
};

export default FullOpeningTimes;



// WEBPACK FOOTER //
// ./containers/LightHomePage/FullOpeningTimes.js